export const site_url='https://newadmin.apmsmarthub.com/api';
export const site_url_img='https://newadmin.apmsmarthub.com/public/storage';
export const invoice_img='assets/img/invoice.png';
export const nodata='assets/ZLoYNL4NvA.json';